module.exports = __webpack_public_path__ + "img/t13.20ee7313.png";